module.exports = __webpack_public_path__ + "static/media/opiniao_comprador_10.990acc56.png";